import { addAllergyToPatientByUserId } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { AddAllergyToPatientByUserIdBody } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchAddAllergyToPatientByUserId(
  userId: string,
  data: AddAllergyToPatientByUserIdBody,
  signal?: AbortSignal
): Promise<unknown> {
  const config = await createLotusRequestConfig({ signal });
  const response = await addAllergyToPatientByUserId(userId, data, config);
  return lotusHealthZod.addAllergyToPatientByUserIdResponse.parse(response.data);
}
